import React, { useEffect, useState } from "react";
import { region, getUserOrgs } from "../utilities/genesysCloudUtils";
import { simplifyOrgName } from "../utilities/helperUtils";
import { ENV } from "../config/clientConfig";
import "../App.css";
import { AlertBlock, DxItemGroup } from "genesys-react-components";

const { redirect, cac1 } = ENV;

export function Org({ setOrg }) {
  const storedTrustors = JSON.parse(localStorage.getItem("trustors"));
  const [userOrg, setUserOrg] = useState();
  const [home] = useState({ organization: cac1.DEV });
  const [trustors] = useState(!storedTrustors ? [home] : storedTrustors);
  const [trustorItems, setTrustorItems] = useState([]);
  const [selectedTrustor, setSelectedTrustor] = useState(null);

  useEffect(() => {
    getUserOrgs().then((data) => {
      setOrg(simplifyOrgName(data.organization.name));
      setUserOrg(data);
      if (data.organization.id === cac1.DEV.id)
        return localStorage.setItem(
          "trustors",
          JSON.stringify(data.trustors.concat(home))
        );
    });
  }, [home, trustors]); // eslint-disable-line react-hooks/exhaustive-deps

  // Transform trustors into DxItemGroup format
  useEffect(() => {
    if (trustors.length > 0 && userOrg) {
      const items = trustors
        .sort((a, b) =>
          simplifyOrgName(a.organization.name).localeCompare(
            simplifyOrgName(b.organization.name)
          )
        )
        .map((trustor, index) => {
          const orgName = simplifyOrgName(trustor.organization.name);
          return {
            id: trustor.organization.id,
            label: trustors.length === 1 ? "REFRESH" : orgName,
            value: trustor.organization.id,
            isSelected: userOrg.organization.id === trustor.organization.id,
            clientId: cac1[orgName]?.clientId,
          };
        });

      setTrustorItems(items);

      // Set the currently selected trustor
      const currentTrustor = items.find((item) => item.isSelected);
      if (currentTrustor) {
        setSelectedTrustor(currentTrustor);
      }
    }
  }, [trustors, userOrg, simplifyOrgName]); // eslint-disable-line react-hooks/exhaustive-deps

  const switchOrg = (orgId, clientId) => {
    let redirectURL = `https://login.${region}/oauth/authorize?client_id=${clientId}&response_type=token&state=${region}&redirect_uri=${redirect}&target=${orgId}`;
    return redirectURL;
  };

  const handleTrustorChanged = (item) => {
    if (item && item.clientId) {
      const redirectURL = switchOrg(item.value, item.clientId);
      window.location.href = redirectURL;
    }
  };

  return (
    <>
      {userOrg ? (
        <div className="org-status-panel">
          <div className="org-context-block">
            <span className="org-status-label">Current organization</span>
            <span className="org-current-name">{userOrg.organization.name}</span>
            <div className="org-status-row org-status-row-compact">
              {userOrg.token.clonedUser ? (
                <span className="status-badge-warning">Clone session</span>
              ) : (
                <span className="status-badge">Primary session</span>
              )}
              {userOrg.token.clonedUser && (
                <a
                  className="org-context-link"
                  href={switchOrg(
                    home.organization.id,
                    cac1[simplifyOrgName(userOrg.organization.name)].clientId
                  )}
                >
                  Return to DEV
                </a>
              )}
            </div>
          </div>

          <div className="org-switcher-block">
            {trustorItems.length > 0 &&
              userOrg.token.homeOrganization.id === home.organization.id && (
                <DxItemGroup
                  className="org-switcher"
                  title="Switch organization"
                  items={trustorItems}
                  format="dropdown"
                  selectedItem={selectedTrustor}
                  onItemChanged={handleTrustorChanged}
                />
              )}
            {userOrg.token.homeOrganization.id === home.organization.id ? (
              <div>
                {trustors.length === 1 && (
                  <a
                    className="org-context-link"
                    href={switchOrg(
                      home.organization.id,
                      cac1[simplifyOrgName(userOrg.organization.name)].clientId
                    )}
                  >
                    REFRESH
                  </a>
                )}
              </div>
            ) : (
              <AlertBlock
                title="Org Switcher is unavailable as the detected user is not logged
                  in through DEV or this is a cloned user."
                // alertType='info'
                collapsible={false}
                autoCollapse={false}
                indentation={1}
                className="clazzy-alertblock m-0"
              />
            )}
          </div>

          <div className="org-identity-panel">
            <div className="org-identity-heading">
              <span className="org-identity-primary">{userOrg.name}</span>
            </div>
            <div className="org-identity-list">
              <div className="org-identity-token">
                <span className="org-status-label">User ID</span>
                <kbd className="kbd">{userOrg.id}</kbd>
              </div>
              <div className="org-identity-token">
                <span className="org-status-label">Org ID</span>
                <kbd className="kbd">{userOrg.organization.id}</kbd>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <span className="org-status-label">Loading organization context...</span>
      )}
    </>
  );
}
